var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal-image",attrs:{"displayCross":true},on:{"close":_vm.closeModal}},[_c('img',{attrs:{"src":_vm.imgPath}})])}
var staticRenderFns = []

export { render, staticRenderFns }